module.exports = __webpack_public_path__ + "static/media/texas.b24b3824.svg";